/**
 * The Contacts tab's local palette — the two colours its cards decide for
 * themselves, kept in one place so Key roles and General contractors can't
 * drift apart.
 */

/**
 * The border on a box nested INSIDE a section card — a role slot, a GC record,
 * the docs rail.
 *
 * The drilldown's shared card line (#e3e8ef / slate-200) is tuned for a card
 * sitting on the page's grey background. These boxes sit on WHITE, inside
 * another card, where that value nearly disappears and the cards stop reading
 * as separate objects. This is the same cool-slate hue one step darker — enough
 * edge to separate them, still a hairline rather than a rule.
 */
export const BOX_LINE = "#dbe2ec";

/**
 * The "not assigned" palette for Key roles.
 *
 * An unfilled role is a GAP, not an error — it should catch the eye scanning
 * the grid without turning the card into a warning banner. The shared
 * `TAB_TOKENS` warn ramp (#fffbeb / #fde68a) is tuned for a one-off alert
 * strip; repeated across a whole grid of cards, a meter and a chip row, that
 * yellow reads as highlighter. These are the same hue desaturated toward sand,
 * so six empty slots sit quietly side by side.
 *
 * `ink` is deliberately NOT softened — the label still has to read, and it is
 * the one part that carries meaning rather than area.
 */
export const MISSING = {
  /** Card wash. */
  fill: "#fdfaf5",
  /** Card border, chip border, meter stripe base. */
  line: "#ead9bd",
  lineHover: "#d6bf99",
  /** Chip fill — a touch warmer than the card so a chip still reads as a chip. */
  chipFill: "#fbf5ea",
  /** The meter's unfilled segment: stripes over a base. */
  hatchBase: "#f8f2e8",
  hatchStripe: "#e3d0ac",
  /** Label + role name. */
  ink: "#b45309",
};

export default MISSING;
